import { boolean, object, optional, string, enums, record } from 'superstruct';

export const careDiscoveryConfigSchema = object({
  showGetAssistanceNowSubheading: optional(boolean()),
  showProviderAvailability: optional(boolean()),
  masonryAppId: optional(
    object({
      left: string(),
      right: optional(string()),
    }),
  ),
  masonryAppVersion: optional(enums(['1.5', '2.0'])),
  getCareLandingMasonryQueryParams: optional(record(string(), string())),
});
